<script setup lang="ts">
    import StemSelection from '@/views/3d-planner/stem/components/StemSelection.vue';
    import StemTransform from '@/views/3d-planner/stem/components/StemTransform.vue';
    import OptimisationTargets from '@/views/3d-planner/components/OptimisationTargets.vue';
    import { useStemOverlayViewModel } from '@/views/3d-planner/stem/useStemOverlayViewModel';
    import { PLANNER_TARGETS } from '@/domain/analytics/analyticsTargets';

    const vm = useStemOverlayViewModel();
</script>

<template>
    <div class="expansion-panel bg-surface-light d-flex flex-column">
        <div class="panel-content d-flex flex-column ga-2 pa-5 pb-0">
            <optimisation-targets :data-analytics-id="PLANNER_TARGETS.optimisationTargets" />
            <stem-selection />
            <app-divider />
            <stem-transform />
            <div class="actions" :data-analytics-id="PLANNER_TARGETS.stemResetButtonGroup">
                <app-button-secondary
                    v-if="vm.hasManualStemTransform"
                    class="w-100"
                    @click="vm.resetStemTransform()"
                    >Reset Position</app-button-secondary
                >
                <app-button-secondary
                    class="w-100"
                    :disabled="vm.isResetStemDisabled"
                    :data-analytics-id="PLANNER_TARGETS.stemResetButton"
                    @click="vm.resetStem()"
                    >Reset</app-button-secondary
                >
            </div>
        </div>
    </div>
</template>

<style scoped>
    .actions {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 0 18px 18px 18px;
        margin-bottom: 18px;
        margin-top: 20px;
        gap: 8px;
    }

    .expansion-panel {
        width: 400px;
        border-radius: 12px;
        height: 100%;
    }

    .panel-content {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        scrollbar-width: thin;
        scrollbar-gutter: stable both-edges;
        scrollbar-color: rgb(var(--v-theme-on-increment-grey)) #efefef;
    }
</style>
